<div #splashScreen class="m-splash-screen">
    <img [attr.src]="splashScreenImage" alt="Logo" style="width: 150px; margin-bottom: 30px;">
    <div>{{ splashScreenService.loaderText || '' }}</div>
</div>
<img [attr.src]="splashScreenImage" [ngStyle]="splashScreenService.getLoaderStyles()" alt="InnerLogo">
<router-outlet></router-outlet>
